import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/ordiginal.webp';
import screenshot_target from '../../../images/letterfunnel/jordyonrust.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Jordy Onrust"
      firstname="Jordy"
      companyname="ORdigiNAL"
      competition="Speech Processing Solutions en G2 Speech"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/jordyonrust.js